module.exports = __webpack_public_path__ + "static/img/w3.05f5a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/w3.png
// module id = UkNQ
// module chunks = 1